'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareComponents = undefined;

var _withRedux = require('../../decorators/withRedux');

var _BusinessCompare = require('./fr/BusinessCompare');

var _BusinessCompare2 = _interopRequireDefault(_BusinessCompare);

var _BusinessCompare3 = require('./jp/BusinessCompare');

var _BusinessCompare4 = _interopRequireDefault(_BusinessCompare3);

var _BusinessCompare5 = require('./it/BusinessCompare');

var _BusinessCompare6 = _interopRequireDefault(_BusinessCompare5);

var _BusinessCompare7 = require('./de/BusinessCompare');

var _BusinessCompare8 = _interopRequireDefault(_BusinessCompare7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  fr: (0, _withRedux.withRedux)(_BusinessCompare2.default),
  jp: (0, _withRedux.withRedux)(_BusinessCompare4.default),
  it: (0, _withRedux.withRedux)(_BusinessCompare6.default),
  de: (0, _withRedux.withRedux)(_BusinessCompare8.default)
};

// This export is used by consuming application

var compareComponents = exports.compareComponents = {
  fr: _BusinessCompare2.default,
  jp: _BusinessCompare4.default,
  it: _BusinessCompare6.default,
  de: _BusinessCompare8.default
};